var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import draggable from 'vuedraggable';
import CarouselItem from './assemblyItems/carousel';
import CategoryItem from './assemblyItems/category';
import RecommendItem from './assemblyItems/recommend';
import QuickLinkItem from './assemblyItems/quickLink';
var defaultPicMap = {
    '6': 'https://cgptdoc.acescm.cn/shopping/frequent_goods.png',
    '7': 'https://cgptdoc.acescm.cn/shopping/order_again.png'
};
var Preview = (function (_super) {
    __extends(Preview, _super);
    function Preview() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.drag = false;
        _this.carouselConfig = [];
        _this.categoryConfig = [];
        _this.freGoodsConfig = [];
        _this.orderAgainConfig = [];
        _this.singleConfig = [];
        _this.doubleConfig = [];
        _this.goodsConfig = [];
        return _this;
    }
    Preview.prototype.mounted = function () {
        this.initConfig();
    };
    Preview.prototype.initConfig = function () {
        this.carouselConfig = [
            {
                front_id: 'carousel-config',
                type: 4,
                typeName: 'carousel-item',
                class: 'subassembly-target',
                data: {
                    is_show: 1,
                    images: [
                        { url: '/static/image/Decoration/banner.png' },
                    ]
                },
            }
        ];
        this.categoryConfig = [
            {
                front_id: 'category-config',
                type: 5,
                typeName: 'category-item',
                class: 'subassembly-target',
                data: {},
            }
        ];
        this.freGoodsConfig = [
            {
                front_id: 'fre-goods-config',
                type: 6,
                typeName: 'quick-link-item',
                class: 'subassembly-target',
                data: {
                    is_show: 1,
                    type: 6,
                    field_name: '常购商品',
                    button_text: '常购商品GO',
                    images: [
                        {
                            url: defaultPicMap['6'],
                        },
                    ]
                },
            }
        ];
        this.orderAgainConfig = [
            {
                front_id: 'order-again-config',
                type: 7,
                typeName: 'quick-link-item',
                class: 'subassembly-target',
                data: {
                    is_show: 1,
                    type: 7,
                    field_name: '再来一单',
                    button_text: '再来一单GO',
                    images: [
                        {
                            url: defaultPicMap['7'],
                        },
                    ]
                },
            }
        ];
        this.singleConfig = [
            {
                front_id: 'recommend-config-1',
                type: 1,
                typeName: 'recommend-item',
                class: 'subassembly-target',
                data: {
                    type: 1,
                    field_name: '大牌特惠',
                    images: [
                        { url: '/static/image/Decoration/singlerecommend.png' }
                    ]
                }
            }
        ];
        this.doubleConfig = [
            {
                front_id: 'recommend-config-2',
                type: 2,
                typeName: 'recommend-item',
                class: 'subassembly-target',
                data: {
                    type: 2,
                    field_name: '发现好物',
                    images: [
                        { url: '/static/image/Decoration/doublerecommend1.png' },
                        { url: '/static/image/Decoration/doublerecommend2.png' },
                        { url: '/static/image/Decoration/doublerecommend3.png' },
                        { url: '/static/image/Decoration/doublerecommend4.png' },
                    ]
                },
            }
        ];
        this.goodsConfig = [
            {
                front_id: 'recommend-config-3',
                type: 3,
                typeName: 'recommend-item',
                class: 'subassembly-target',
                data: {
                    type: 3,
                    field_name: '商城俏货',
                    images: [
                        {
                            url: '/static/image/Decoration/goods1.png',
                            goods: {
                                goods_name: '新鲜罗勒叶',
                                goods_price: '73',
                                inventory_unit_name: 'kg',
                                strikethrough_price: 99
                            }
                        },
                        {
                            url: '/static/image/Decoration/goods2.png',
                            goods: {
                                goods_name: '日本种源板栗小南瓜',
                                goods_price: '16',
                                inventory_unit_name: 'kg',
                                strikethrough_price: 29
                            }
                        },
                    ]
                },
            }
        ];
    };
    Preview.prototype.onStart = function () {
        this.drag = true;
    };
    Preview.prototype.onEnd = function () {
        this.initConfig();
        this.drag = false;
    };
    Preview.prototype.onMove = function (e, originalEvent) {
        if (e.relatedContext.element.class == 'subassembly-target') {
            return false;
        }
    };
    Preview = __decorate([
        Component({
            components: {
                draggable: draggable,
                'carousel-item': CarouselItem,
                'category-item': CategoryItem,
                'recommend-item': RecommendItem,
                'quick-link-item': QuickLinkItem,
            }
        })
    ], Preview);
    return Preview;
}(Vue));
export default Preview;
